import React, { useEffect } from 'react';
import * as S from './HomePage.styles';
import RecentSearches from './components/RecentSearches/RecentSearches';
import PopularBusRoutes from './components/PopularBusRoutes/PopularBusRoutes';
import PopularBusOperator from './components/PopuplarBusOperator/PopularBusOperator';
import HomeSearchWidget from './components/HomeSearchWidget/SearchWidget';
import HomeBookingFaq from './components/BookingFaq/BookingFaq';
import AdBanner from './../../components/AdBanner/AdBanner';
import { Helmet } from 'react-helmet';
import Content from './components/Content/Content';
import RTCBanner from './components/RTCBanner/RTCBanner';
import HomeCaroselWrapper from './components/HomeBanner/HomeCarousel/HomeCaroselWrapper';
import OfferBannerWrapper from './components/HomeBanner/OfferBanner/OfferBannerWrapper';
import { useSelector } from 'react-redux';
import { IUserStoreState, userSelector } from '@stencil/user-reducer';
import { getBreadCrumbObj } from '../../utils/common';
import { pushOmniEvents } from '../../utils/PushEvents/Omniture/utils';
import { SkywalkerWeb } from '@growth/skywalker/entries/bus-dweb-home';
import { getSessionStorage } from '../../containers/Common/Utils';

const HomePage = () => {
  const breadCrumb = [{
    "title": "Goibibo",
    "url": "https://www.goibibo.com/"
  },
  {
    "title": "Bus Booking",
    "url": "https://www.goibibo.com/bus/"
  }]

  const breadCrumbObj = getBreadCrumbObj(breadCrumb);

  const userDetails = useSelector(userSelector) as IUserStoreState;
  const isLoggedIn = !!userDetails?.isLoggedIn;
  const {userInfo} = userDetails;
  const eventDetails = {
    page: {
      pageInfo: {
        section: "landing",
        pageName: "landing:domestic bus:landing",
        pageType: "landing",
        lob: "domestic bus",
        siteName: 'GI',
        platform: 'dweb',
        flow: `${"direct-bus"}`,
        loadedComponents: '',
        abVariant: '',
        deviceId: "[DEVICE ID]",
        loyaltyStatus_v44:`${getSessionStorage('loyaltyInfo') || ''}`,
      },
    },
    account: {
      accountInfo: {
        custID: userInfo?.userid?userInfo?.userid:'',
        loginStatus:  isLoggedIn? "Logged-In" : "Guest",
        goCash: userDetails?userDetails.gocashInfo ? userDetails?.gocashInfo?.data?.t_amt : "":'',
        "loyaltyStatus": "[LOYALTY STATUS]",
        "hydraSegment": "[HYDRA SEGMENT]",
      },
    },
  };
  
  useEffect (() => {
    pushOmniEvents({eventName:'pageView', details:eventDetails});
  },[])

  return (
    <>
     <Helmet
        title={"Bus Booking - Online Bus Ticket Booking of all Bus types at best prices"}
        meta={
          [{ name: 'description', content: "Book Bus Tickets online with Goibibo. Bus Ticket Booking for AC Volvo, Sleeper, Luxury and other buses with attractive offers. Get confirmed Bus Reservation tickets at best prices." },
          { name: 'keywords', content: "Goibibo, online bus booking, book bus online, bus booking site, Goibibo buses" },
          { property: 'og:title', content: "Bus Booking - Online Bus Ticket Booking of all Bus types at best prices" },
          { property: 'og:description', content: "Book Bus Tickets online with Goibibo. Bus Ticket Booking for AC Volvo, Sleeper, Luxury and other buses with attractive offers. Get confirmed Bus Reservation tickets at best prices." },
          { property: 'og:image', content: 'https://gos3.ibcdn.com/bus-default-1489655303.jpg' },
          ]
        }
      />
      <Helmet>
        <script type="application/ld+json">{`${JSON.stringify(breadCrumbObj)}`}</script>
      </Helmet>

      <S.HomePageWrapper>
        {/* Add below overlay tag whenever calendar and autosuggest is in the open state */}
        {/* <S.Overlay></S.Overlay> */}
        <S.PageBackground></S.PageBackground>
        <S.PageBackgroundLight></S.PageBackgroundLight>
        <S.PageContentWrapper>
          <S.PageHeader>Bus Ticket Booking</S.PageHeader>
          {/* search widget wrap */}
          <S.SearchBlock>
            <HomeSearchWidget />
            <S.OfferBlock>
              <HomeCaroselWrapper />
              {/* <GoSafeBannerWrapper /> */}
              <OfferBannerWrapper />
            </S.OfferBlock>
          </S.SearchBlock>

          {/* AdBanner */}
          <AdBanner cid="QlVTI0hPTUUjQ0VOVEVS" styles={{margin:'0 0 2rem 0'}}/>

          {/* recent searches */}
          {/* <RecentSearches /> */}
          <SkywalkerWeb
            lobName='bus'
            page="home"
            />


          {/* RTC Buses Banner */}
          <RTCBanner />

          {/* bus popular  routes*/}
          <PopularBusRoutes />

          {/* popular bus operator */}
          <PopularBusOperator />

          <Content />

          {/* faq */}
          <HomeBookingFaq />

          <AdBanner cid="QlVTI0xBTkRJTkcgUEFHRSNCT1RUT00gQkFOTkVSMg==" position="bottom_ad" />

        </S.PageContentWrapper>
      </S.HomePageWrapper>
      </>
  );
};

export default HomePage;
